import axios from 'axios';

import { IDocument, IOrder, IOrderQuantities_Addresses } from '../infrastructure/interfaces';

export default class OrderService {
  static placeOrder(document: IDocument, user_id: string, user_email: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) {
    return new Promise((resolve, reject) => {
      axios
        .post('/orders', { document_id: document.id, user_id, shipEmail: user_email, comments,  orderQuantities_addresses: orderQuantitiesAddresses})
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  static getOrdersList(userID: string) {
    return new Promise((resolve, reject) => {
      axios
        .get('/userOrders?userID=' + userID)
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  static getStatuses() {
    return new Promise((resolve, reject) => {
      axios
        .get('/order_status')
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  
  static changeOrderStatus(order: IOrder, status_id: number) {
    return new Promise((resolve, reject) => {
      const newOrder = { ...order, status_id };
      axios
        .put(`/orders/${order.id}`, newOrder)
        .then((res) => {
          resolve(newOrder);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  static getAdminOrderList(startIndex: Number, listSize: Number, orderCategory: Number) {
    return new Promise((resolve, reject) => {
      axios
        .get('/orders/admin?status_id=' + orderCategory + '&returnCount=' + listSize + '&startIndex=' + startIndex)
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  static getOrderCount(status_id: Number) {
    return new Promise((resolve, reject) => {
      axios
        .get('/ordersCount', { params: { status_id }})
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  static getOrdersPlacedReport() {
    return new Promise((resolve, reject) => {
      axios
        .get('/ordersPlacedReport')
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  static getOrderCostReport() {
    return new Promise((resolve, reject) => {
      axios
        .get('/ordersCostReport')
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  static getCostReportFile(fileName: string) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/getCostReport`, { params: { fileName }, responseType: 'blob' })
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  }
  static getOrderAnalyticsReport(fileName: string) {
    return new Promise((resolve, reject) => {
      axios
          .get('/getOrderAnalyticsReport', { params: { fileName }, responseType: 'blob'})
          .then((response) => {
            resolve(response.data);
          })
          .catch(error => reject(error));
    });
  }
  static getProductAnalyticsReport(fileName: string) {
    return new Promise((resolve, reject) => {
      axios
          .get('/getProductAnalyticsReport', { params: { fileName }, responseType: 'blob'})
          .then((response) => {
            resolve(response.data);
          })
          .catch(error => reject(error));
    });
  }
  static deleteOrder(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/orders/${id}`)
        .then((res) => {
          const { id } = res.data;
          resolve(id);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/OrderService.ts